
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = () => {
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <section 
      className="py-20 text-white relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=beautiful%20sunset%20over%20calm%20ocean%20waters%20with%20gentle%20waves%2C%20peaceful%20seascape%2C%20warm%20golden%20and%20orange%20colors%20in%20sky%2C%20professional%20travel%20photography%2C%20serene%20and%20tranquil%20atmosphere%2C%20perfect%20for%20newsletter%20background%2C%20inspiring%20travel%20destination&width=1920&height=600&seq=newsletter-bg&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Get Travel Inspiration
          </h2>
          <p className="text-xl mb-8 text-gray-200">
            Subscribe to our newsletter and receive exclusive travel deals, destination guides, and insider tips directly to your inbox.
          </p>
          
          {subscribed ? (
            <div className="bg-green-500 text-white px-6 py-4 rounded-lg inline-flex items-center">
              <i className="ri-check-line mr-2"></i>
              Thank you for subscribing! Check your email for exclusive deals.
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row max-w-md mx-auto gap-4">
              <div className="flex-1">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-6 py-4 rounded-lg text-gray-900 focus:ring-2 focus:ring-blue-500 focus:outline-none text-sm"
                />
              </div>
              <Button onClick={handleSubscribe} size="lg" className="px-8">
                <i className="ri-mail-line mr-2"></i>
                Subscribe
              </Button>
            </div>
          )}
          
          <p className="text-sm text-gray-300 mt-4">
            No spam, unsubscribe at any time. We respect your privacy.
          </p>
        </div>
      </div>
    </section>
  );
}
